/* Generated by build-cart-assets.py. Never activate before checkout acceptance tests. */
(()=>{
// Pure calculation shared by the cart adapter and order-processing integration.
// Input subtotal must already exclude magazines/gift cards and include all allocated discounts.
function rewardFor(cents) {
  if (!Number.isSafeInteger(cents) || cents < 0) throw new TypeError('Expected nonnegative integer cents');
  return cents >= 100000 ? { magazines: 2, voucherCents: 10000, futureMinimumCents: 0 }
    : cents >= 50000 ? { magazines: 2, voucherCents: 5000, futureMinimumCents: 0 }
    : cents >= 25000 ? { magazines: 1, voucherCents: 2500, futureMinimumCents: 0 }
    : cents >= 12500 ? { magazines: 1, voucherCents: 0, futureMinimumCents: 0 }
    : { magazines: 0, voucherCents: 0, futureMinimumCents: 0 };
}
function eligibleSubtotal(cart, magazineVariantIds) {
  const ids = new Set(magazineVariantIds.map(String));
  return cart.items.filter(item => !ids.has(String(item.variant_id)) && !item.gift_card)
    .reduce((sum, item) => {
      if (!Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) throw new TypeError('Invalid cart money');
      return sum + item.final_line_price;
    }, 0);
}


// The server-side discount owns eligibility. This adapter never makes an item free.
function createGiftCart({ enabled = false, catalog, root = '/', onStatus = () => {}, fetcher = globalThis.fetch, onUpdated = () => {} }) {
  let busy = false;
  const ids = catalog.map(m => String(m.variants.nodes[0].id.split('/').pop()));
  const isGift = item => ids.includes(String(item.variant_id)) && item.properties?._tomo_reward === 'ldw-2026';
  const base = root.endsWith('/') ? root : root + '/';
  async function request(path, data) {
    const response = await fetcher(base + path, data ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {cache:'no-store'});
    if (!response.ok) throw new Error('Your cart could not be updated. Please refresh your cart and try again.');
    return response.json();
  }
  async function inspect() {
    const cart = await request('cart.js');
    if (cart.currency !== 'USD') throw new Error('This offer is currently configured for USD orders only.');
    if (cart.cart_level_discount_applications?.length) throw new Error('Remove the order-wide discount before choosing complimentary magazine gifts.');
    const subtotal = eligibleSubtotal(cart, ids);
    return { cart, subtotal, reward: rewardFor(subtotal) };
  }
  async function removeGifts(cart) {
    const updates = Object.fromEntries(cart.items.filter(isGift).map(i => [i.key, 0]));
    if (Object.keys(updates).length) await request('cart/update.js', {updates});
  }
  async function select(variantIds) {
    if (!enabled) throw new Error('Magazine rewards are not live yet.');
    if (busy) throw new Error('Please wait for your cart update to finish.');
    busy = true;
    let mutationStarted = false;
    try {
      if (!Array.isArray(variantIds)) throw new Error('Choose eligible magazine titles.');
      const chosen = [...new Set(variantIds.map(String))];
      if (chosen.length !== variantIds.length || chosen.some(id => !ids.includes(id))) throw new Error('Choose different eligible magazine titles.');
      const {cart, reward} = await inspect();
      if (chosen.length > reward.magazines) throw new Error('Your cart no longer qualifies for that many gifts.');
      mutationStarted = true;
      // Only this campaign's marked gift lines are replaced; paid subscriptions survive.
      await removeGifts(cart);
      if (chosen.length) await request('cart/add.js', {items:chosen.map(id => ({id:Number(id),quantity:1,properties:{'_tomo_reward':'ldw-2026'}}))});
      const after = await inspect();
      const giftLines = after.cart.items.filter(isGift);
      const exact = giftLines.length === chosen.length && chosen.every(id => giftLines.filter(i => String(i.variant_id) === id).length === 1);
      if (!exact || giftLines.some(i => i.quantity !== 1 || i.final_line_price !== 0) || giftLines.length > after.reward.magazines) {
        throw new Error('Your gift selection could not be verified at no charge.');
      }
      onStatus('Your magazine selection has been updated.');
      onUpdated(after.cart);
      return after;
    } catch (error) {
      if (!mutationStarted) throw error;
      // A failed add response may still have changed the cart. Re-read and remove
      // only marked campaign gifts, then confirm cleanup before claiming success.
      try {
        const current = await request('cart.js');
        await removeGifts(current);
        const cleaned = await request('cart.js');
        if (cleaned.items.some(isGift)) throw new Error('Gift cleanup incomplete');
        onUpdated(cleaned);
      } catch {
        throw new Error('We could not confirm your cart update. Open your cart and remove any unexpected magazine gifts before checkout.');
      }
      throw new Error('We could not apply your complimentary gifts, so we removed the campaign gift selections. Your paid items were kept. Please try again or contact us.');
    } finally { busy = false; }
  }
  return { inspect, select, isGift };
}


const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
function mount(node) {
  if(node.dataset.initialized || node.dataset.enabled !== 'true') return;
  node.dataset.initialized='true';
  const catalog=JSON.parse(node.querySelector('[data-catalog]').textContent);
  const status=node.querySelector('[data-status]'), controls=[...node.querySelectorAll('input[type="checkbox"]')], save=node.querySelector('[data-save]'), refresh=node.querySelector('[data-refresh]');
  let state=null, working=false;
  const api=createGiftCart({enabled:true,catalog,root:node.dataset.root,onUpdated:cart=>document.dispatchEvent(new CustomEvent('tomo:cart-updated',{detail:cart}))});
  function summary() {
    const cap=state.reward.magazines;
    status.textContent=cap ? `Your merchandise qualifies for ${cap} annual ${cap===1?'subscription':'subscriptions'}${state.reward.voucherCents ? ' + a '+money(state.reward.voucherCents)+' future voucher':''}. Choose your titles below.` : `Add ${money(12500-state.subtotal)} in eligible merchandise to unlock a year of reading.`;
    for(const input of controls) input.disabled=working || (!input.checked && (cap===0 || controls.filter(c=>c.checked).length>=cap));
    save.disabled=working; refresh.disabled=working;
  }
  async function load() {
    if(working)return;
    working=true;save.disabled=true;refresh.disabled=true;
    try {
      state=await api.inspect();
      const chosen=new Set(state.cart.items.filter(api.isGift).map(i=>String(i.variant_id)));
      controls.forEach(i=>{i.checked=chosen.has(i.value)});
      working=false;summary();
    } catch(e) {status.textContent=e.message;working=false;refresh.disabled=false;controls.forEach(i=>i.disabled=true)}
  }
  controls.forEach(i=>i.addEventListener('change',()=>{if(state)summary()}));
  refresh.addEventListener('click',load);
  save.addEventListener('click',async()=>{
    if(working || !state)return;
    working=true;summary();status.textContent='Updating your magazine gifts…';
    try {state=await api.select(controls.filter(i=>i.checked).map(i=>i.value));working=false;summary();status.textContent='Your gifts are in your cart at no charge. Your paid items were kept.'}
    catch(e) {working=false;status.textContent=e.message;save.disabled=true;refresh.disabled=false;controls.forEach(i=>i.disabled=true)}
  });
  // Explicit refresh avoids theme-specific assumptions about cart drawer events.
  node.hidden=false;load();
}
function scan(){document.querySelectorAll('[data-tomo-gift-chooser]').forEach(mount)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
document.addEventListener('shopify:section:load',scan);

})();
